// extracted by mini-css-extract-plugin
export default {"lists":"rofwY","oftenSearch":"_nYRB","categoryFound":"e3EXb","found":"PHPAV","requestTite":"bKDU9","requestSubtitle":"Le_J5","tips":"yiymj","history":"M2UIa"};